export default __webpack_public_path__ + "static/media/portfolio9.266154c6.webp";